import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview, initGA4 } from '@/lib/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => { trackPageview(location.pathname); }, [location.pathname]);
  useEffect(() => { initGA4(); }, []);
  return null;
};

export default AnalyticsTracker;
